import {
  AdditionalFormFieldProps,
  BaseFormFieldDefinition,
} from "@pimo/pimo-components/src/lib/pimo-components/pimo-form/form-field";
import { FC, memo, useState } from "react";

export const MEMO_RICH_TEXT_FIELD_TYPE = "memoRichText" as const;

export type MemoRichTextFieldDefinition = BaseFormFieldDefinition<
  typeof MEMO_RICH_TEXT_FIELD_TYPE
> & {
  multiline?: boolean;
  maxLength?: { value: number; message: string };
  minLength?: { value: number; message: string };
};

type MemoRichTextProps = MemoRichTextFieldDefinition &
  AdditionalFormFieldProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getElementForFormFieldByType?: (type: string) => FC<any> | undefined;
  };

const MemoRichTextInner = (props: MemoRichTextProps) => {
  const { getElementForFormFieldByType } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [RealRichText] = useState<FC<any> | null>(
    () => getElementForFormFieldByType?.("rich-text") ?? null
  );

  return RealRichText ? <RealRichText {...props} type="rich-text" /> : null;
};

// Re-render only when this field's own identity/state changes — not when some other field is typed
// in. The editor's internal useWatch handles updates to its own value.
export const MemoRichTextFormField = memo(
  MemoRichTextInner,
  (prev, next) =>
    prev.name === next.name &&
    prev.errorMessage === next.errorMessage &&
    prev.disabled === next.disabled &&
    prev.label === next.label
);
